import { type Static, Type } from '@sinclair/typebox';
import { ClientEntityMetaDataSchema } from './clientEntities.js';

export const CatalogSchema = Type.Object({
  language: Type.String(),
  name: Type.String(),
  currency: Type.String(),
  refresh_date: Type.String(),
  latest_price_update_date: Type.Optional(Type.String()),
  taxonomies: Type.Array(Type.String()),
  similarity_threshold: Type.Record(Type.String(), Type.Number()),
  batch_analysis_additional_attributes_columns: Type.Optional(
    Type.Array(Type.Object({ label: Type.String(), key: Type.String() })),
  ),
  client_entity_filters: Type.Optional(ClientEntityMetaDataSchema),
});
export type CatalogDTO = Static<typeof CatalogSchema>;

// =====================================================================================================================
// List Catalogs
// =====================================================================================================================

export const ListCatalogsResponseSchema = Type.Array(
  Type.Object({
    organization: Type.String(),
    catalogs: Type.Array(CatalogSchema),
  }),
);
export type ListCatalogsResponse = Static<typeof ListCatalogsResponseSchema>;
